import React, { useEffect, useState } from "react";

import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import DownloadIcon from "@mui/icons-material/Download";
import { get } from "lodash";
import DocumentsService from "../../services/DocumentsService";
import { Stack } from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DocumentPreviewDialog = ({ open, handleClose, documentInfo }) => {
  const [fileUrl, setFileUrl] = useState();
  const [fileType, setFileType] = useState();

  const downloadFile = async () => {
    try {
      const docId = get(documentInfo, "id");
      if (!docId) return;

      const response = await DocumentsService.downloadFile(docId);

      const contentType =
        response.headers["content-type"] || "application/octet-stream";

      const blob = new Blob([response.data], { type: contentType });

      const url = URL.createObjectURL(blob);

      setFileUrl(url);
      setFileType(contentType);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    downloadFile();
  }, [documentInfo]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      slots={{
        transition: Transition,
      }}
    >
      <AppBar
        sx={{ position: "relative", backgroundColor: "var(--light-grey-bg)" }}
      >
        <Toolbar>
          <IconButton edge="start" aria-label="close" onClick={handleClose}>
            <CloseIcon htmlColor="var(--red-color)" />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, color: "var(--text-color)" }}
            variant="h6"
            component="div"
          >
            {get(documentInfo, "filename", "-")}
          </Typography>
          <Button
            autoFocus
            download={get(documentInfo, "filename", "document.pdf")}
            href={fileUrl}
            disabled={!fileUrl || !fileType}
            variant="contained"
            sx={{ backgroundColor: "var(--green-color)" }}
            startIcon={<DownloadIcon />}
          >
            Enregistrer
          </Button>
        </Toolbar>
      </AppBar>
      {fileUrl && fileType?.includes("pdf") && (
        <iframe
          src={fileUrl}
          title="pdf-viewer"
          style={{ width: "100%", height: "100%" }}
        />
      )}

      {fileUrl && fileType?.startsWith("image/") && (
        <Stack justifyContent="center" alignItems="center" height="100%">
          <img src={fileUrl} alt="preview" />
        </Stack>
      )}
    </Dialog>
  );
};

export default DocumentPreviewDialog;
